import { blend, clamp } from './interpolate';

const scoreDso = (dso) => {
  if (dso <= 30) return 85;
  if (dso <= 45) return 85 - ((dso - 30) / 15) * (85 - 65);
  if (dso <= 60) return 65 - ((dso - 45) / 15) * (65 - 45);
  if (dso <= 90) return 45 - ((dso - 60) / 30) * (45 - 20);
  return clamp(20 - (dso - 90) * 0.3, 10, 20);
};

const scoreCollection = (rate) => {
  if (rate >= 95) return 90;
  if (rate >= 90) return 72 + ((rate - 90) / 5) * (90 - 72);
  if (rate >= 85) return 55 + ((rate - 85) / 5) * (72 - 55);
  if (rate >= 75) return 35 + ((rate - 75) / 10) * (55 - 35);
  return clamp(35 - (75 - rate) * 1.2, 10, 35);
};

export const scoreD2 = (inputs) => {
  const dso = scoreDso(inputs.weightedDso);
  const collection = scoreCollection(inputs.collectionRate);
  const diversity = clamp(30 + inputs.distinctPaymentMeans * 12, 0, 90);

  const score = blend([
    { score: dso, weight: 0.55 },
    { score: collection, weight: 0.3 },
    { score: diversity, weight: 0.15 },
  ]);

  return { score, subScores: { dso, collection, diversity } };
};
